import { netsparkAxios } from 'core/services/HTTPService';
import { IChartItem } from 'core/models/Recharts.models';
import { getBillingRequestTypeChartUrl } from 'pages/Dashboard/api/apiUrls';
// eslint-disable-next-line no-unused-vars
import { TPeriod } from 'shared/CustomRangePicker/CustomRangePicker.models';

const getRequestType = (signal: AbortSignal, params: TPeriod) => netsparkAxios
  .get<IChartItem[]>(getBillingRequestTypeChartUrl, { signal, params });

export default getRequestType;
